<template>
  <DataTable :value="locations" :paginator="false" :rows="locations.length"
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    currentPageReportTemplate="({first} - {last} of {totalRecords})" :rowsPerPageOptions="[10, 20, 50, 100]"
    class="p-datatable-sm admin-datatable inventory-location-table" tableClass="border-left border-right border-bottom"
    dataKey="id" breakpoint="992px">
    <Column field="id" header="ID" style="width: 10%">
    </Column>
    <Column field="row" header="Row">
      <template #body="slotProps">
        <div>{{ slotProps.data.row }}</div>
      </template>
    </Column>
    <Column field="column" header="Column">
      <template #body="slotProps">
        <div>{{ slotProps.data.column }}</div>
      </template>
    </Column>
    <Column field="shelf" header="Shelf">
      <template #body="slotProps">
        <div>{{ slotProps.data.shelf }}</div>
      </template>
    </Column>
    <Column field="slot" header="Slot">
      <template #body="slotProps">
        <div>{{ slotProps.data.slot }}</div>
      </template>
    </Column>
    <Column field="pick_order" header="Pick Order">
      <template #body="slotProps">
        <div>{{ slotProps.data.pick_order }}</div>
      </template>
    </Column>
    <Column field="" header="" v-if="!!handleDelete">
      <template #body="slotProps">
        <a class="" href="javascript:void(0)" @click="handleDelete($event, slotProps.data)" v-if="!!handleDelete"><i
            class="fa fa-trash text-danger"></i></a>
      </template>
    </Column>
  </DataTable>
</template>

<script>

export default {
  components: {
  },
  props: {
    inventoryLocations: Array,
    handleDelete: Function,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    locations() {
      return this.inventoryLocations || []
    },
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
.inventory-location-table {

  .p-datatable thead.p-datatable-thead th,
  .p-datatable-table thead.p-datatable-thead th,
  .p-datatable-sm thead.p-datatable-thead th {
    background: gray !important;
  }

  .p-datatable thead.p-datatable-thead th.p-highlight,
  .p-datatable-table thead.p-datatable-thead th.p-highlight,
  .p-datatable-sm thead.p-datatable-thead th.p-highlight {
    color: gray !important;
  }

  .p-column-header-content {
    padding-left: 0.25rem !important;
  }

  .p-datatable-tbody td {
    padding-left: 0.25rem !important;
  }

}
</style>
